<footer class="footer">
  <img
    alt="logo vigilado"
    [src]="baseUrl + '/assets/images/legal-vigilado.svg'"
    class="footer-legal"
  />

  <div class="footer-legal-cont"></div>

  <div class="footer-info">
    <app-text
      text="Políticas de privacidad / T&C"
      [fontSize]="10"
      [lineHeight]="10"
      colorClass="color-gray-200"
      [customStyles]="{ marginRight: '10px' }"
    >
    </app-text>

    <app-text
      text="© Copyright 2022 Redeban. "
      [fontSize]="10"
      [lineHeight]="10"
      colorClass="color-secondary-400"
      [customStyles]="{ marginRight: '3px' }"
    >
    </app-text>

    <app-text
      text=" Todos los derechos reservados"
      [fontSize]="10"
      [lineHeight]="10"
      colorClass="color-gray-200"
    >
    </app-text>
  </div>

  <div class="footer-socialmedia">
    <app-text
      *ngIf="isMobile; else desktop"
      text="Nuestras redes"
      style="width: 100%; text-align: center"
    >
    </app-text>

    <ng-template #desktop>
      <app-text
        text="Nuestras redes"
        [fontSize]="10"
        fontWeight="600"
        [lineHeight]="16"
        colorClass="color-gray-200"
      >
      </app-text>
    </ng-template>

    <a
      *ngFor="let social of socialMedia"
      [href]="social.href"
      target="_blank"
      rel="noopener noreferrer"
      class="footer-icon"
    >
      <img alt="icono de social media" [src]="baseUrl + '/assets/icons/' + social.icon"
    /></a>
  </div>
</footer>
